import { clsx as cn } from 'clsx';
import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import { type ISuggestionDefaultItem } from '../../../types';

import styles from './styles.module.css';

export const SuggestionDesktopDefaultItem: React.FC<
  React.PropsWithChildren<
    { isSelected: boolean; onClick(): void; iconMargin: number } & ISuggestionDefaultItem<unknown> &
      Pick<React.DOMAttributes<HTMLElement>, 'onMouseEnter' | 'onMouseMove' | 'onMouseLeave'>
  >
> = props => {
  return (
    <li
      className={cn(styles['item'], props.isSelected && styles['item-selected'])}
      role="option"
      aria-selected={props.isSelected}
      tabIndex={-1}
      onClick={props.onClick}
      onMouseLeave={props.onMouseLeave}
      onMouseEnter={props.onMouseEnter}
      onMouseMove={props.onMouseMove}
      data-testid="suggesttion-desktop-default-item"
    >
      {props.leftIcon && <div className={styles['left-icon']}>{props.leftIcon}</div>}
      <div className={styles['text-area']} style={{ marginLeft: props.iconMargin }}>
        <div className={styles['title']}>{props.children}</div>
        {props.subtitle && (
          <div className={styles['subtitle']}>
            <UIText2 color="text-secondary-default">{props.subtitle}</UIText2>
          </div>
        )}
      </div>
      {props.rightIcon && <div className={styles['right-icon']}>{props.rightIcon}</div>}
    </li>
  );
};

SuggestionDesktopDefaultItem.displayName = 'SuggestionDesktopDefaultItem';
